// extracted by mini-css-extract-plugin
export default {"grid":"Login_grid__IkJ6F","gradient":"Login_gradient__FB73G"};